import axios from 'axios';

export const getRotenSurvey = (branchID, month, type, token) => {
    let newURL = "/roten/get_other_survey_month/" + type + "/" + branchID + "/"  + month
    return axios.get(`${newURL}`, {
        headers: { Authorization: token }
    });
};

export const updateNoteSupFeedBack = (branchID, data, token) => {
    let newURL = "/roten/update_sup_feed_back/" + branchID
    return axios.post(`${newURL}`, data, {
        headers: { Authorization: token }
    });
};
